// Redux
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
// Reducers
import LoginReducer from "./Login/Reducer";
// Sagas
import rootSaga from "./sagas";

const persistConfig = {
    key: "root",
    storage,
  };
const rootReducer = combineReducers({
/**
 * Register your reducers here.
 * @see https://redux.js.org/api-reference/combinereducers
 */
    login: LoginReducer
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
persistedReducer,
composeEnhancers(applyMiddleware(thunk, sagaMiddleware))
);

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export {store, persistor}


// WEBPACK FOOTER //
// ./src/stores/index.js